import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setSitemapActive, type SitemapEntity } from './api';

/** "Только участвующие в построении URL" list filter (applied immediately, like legacy). */
export const OnlySeoActiveFilter = ({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
}) => (
  <div className="checkbox" style={{ margin: 0 }}>
    <label>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      Только участвующие в построении URL
    </label>
  </div>
);

/** Checkbox cell toggling sitemap participation of one entity, then refetching `listKey` queries. */
export const SitemapToggleCell = ({
  entity,
  id,
  isActive,
  listKey,
}: {
  entity: SitemapEntity;
  id: number;
  isActive: boolean;
  listKey: string;
}) => {
  const qc = useQueryClient();
  const mutation = useMutation({
    mutationFn: () => setSitemapActive(entity, id, !isActive),
    onSuccess: () => qc.invalidateQueries({ queryKey: [listKey] }),
  });

  return (
    <input
      type="checkbox"
      checked={isActive}
      disabled={mutation.isPending}
      onChange={() => mutation.mutate()}
    />
  );
};
